const VI_NUMBER = new Intl.NumberFormat('vi-VN');

export function fmtNumber(value) {
    if (value === null || value === undefined || Number.isNaN(value)) return '';
    return VI_NUMBER.format(value);
}

export function fmtPrice(value) {
    if (value === null || value === undefined) return '—';
    return fmtNumber(value);
}

export function fmtChangePct(pct) {
    if (pct === null || pct === undefined || Number.isNaN(pct)) return null;
    const sign = pct > 0 ? '+' : '';
    return `${sign}${pct.toFixed(2)}%`;
}

export function changeTone(pct) {
    if (pct === null || pct === undefined) return 'neutral';
    if (pct > 0) return 'up';
    if (pct < 0) return 'down';
    return 'neutral';
}

export function fmtDateTime(iso) {
    if (!iso) return '';
    try {
        return new Date(iso).toLocaleString('vi-VN');
    } catch {
        return iso;
    }
}

const RELATIVE_UNITS = [
    { limit: 60, divisor: 1, unit: 'giây' },
    { limit: 3600, divisor: 60, unit: 'phút' },
    { limit: 86400, divisor: 3600, unit: 'giờ' },
    { limit: 2592000, divisor: 86400, unit: 'ngày' },
];

export function fmtRelativeTime(iso) {
    if (!iso) return '';
    const target = new Date(iso);
    if (Number.isNaN(target.getTime())) return '';
    const diffSec = Math.floor((Date.now() - target.getTime()) / 1000);
    if (diffSec < 5) return 'vừa xong';
    for (const { limit, divisor, unit } of RELATIVE_UNITS) {
        if (diffSec < limit) {
            return `${Math.floor(diffSec / divisor)} ${unit} trước`;
        }
    }
    return target.toLocaleDateString('vi-VN');
}
